import { array } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import joinClasses from 'webapp/helpers/join-classes';

interface CommonSecurityInfoComponentInterface {
	Element: HTMLDivElement;
	Args: {
		isExtraShown?: boolean;
		isCompact?: boolean;
		hideShortExtras?: boolean;
	};
}

export default class CommonSecurityInfoComponent extends Component<CommonSecurityInfoComponentInterface> {
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('popup') declare popupService: Service.Popup;
	@service('model-manager/sources') declare mmSourcesService: Service.ModelManager.Sources;

	isPopupOpen = false;

	get isAnySourceConnected() {
		return this.mmSourcesService.connectedSourcesCount > 0;
	}

	get isOneOrLessSourceConnected() {
		return this.mmSourcesService.connectedSourcesCount <= 1;
	}

	get areMoreThanTenSourcesConnected() {
		return this.mmSourcesService.connectedSourcesCount > 10;
	}

	get logoSize() {
		return !!this.args.isCompact ? 36 : 45;
	}

	get isShown() {
		return (
			!this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins &&
			!this.areMoreThanTenSourcesConnected
		);
	}

	<template>
		{{#if this.isShown}}
			<div role="button" class="security-info">
				<div
					class={{joinClasses
						(array "security-info__main" (if @isCompact "security-info__main--compact"))
					}}
				>
					<img
						src="/images/svg/secure-data.svg"
						height={{this.logoSize}}
						width="auto"
						alt=""
					/>
					<div>
						<div class="question-title">Your data is secure with us.</div>
						<div>Trusted by thousands of companies.</div>
					</div>
					<img
						src="/images/svg/gdpr-{{this.navigationService.theme.id}}.svg"
						height="40"
						width="auto"
						alt=""
					/>
				</div>
			</div>
		{{/if}}
	</template>
}
